import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Copy = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.64468 15.2833C6.70579 15.2833 5.94468 14.5222 5.94468 13.5833V3.08333C5.94468 2.14445 6.7058 1.38333 7.64468 1.38333H15.6122C16.551 1.38333 17.3122 2.14445 17.3122 3.08333V13.5833C17.3122 14.5222 16.551 15.2833 15.6122 15.2833H7.64468ZM7.34468 13.5833C7.34468 13.749 7.47899 13.8833 7.64468 13.8833H15.6122C15.7778 13.8833 15.9122 13.749 15.9122 13.5833V3.08333C15.9122 2.91765 15.7778 2.78333 15.6122 2.78333H7.64468C7.47899 2.78333 7.34468 2.91765 7.34468 3.08333V13.5833ZM4.88784 18.6167C3.67282 18.6167 2.68784 17.6317 2.68784 16.4167V5.56475C2.68784 4.62587 3.44896 3.86475 4.38784 3.86475H4.60936C4.99596 3.86475 5.30936 4.17815 5.30936 4.56475C5.30936 4.95135 4.99596 5.26475 4.60936 5.26475H4.38784C4.22216 5.26475 4.08784 5.39907 4.08784 5.56475V16.4167C4.08784 16.8585 4.44601 17.2167 4.88784 17.2167H13.1447C13.3104 17.2167 13.4447 17.0824 13.4447 16.9167V16.5365C13.4447 16.1499 13.7581 15.8365 14.1447 15.8365C14.5313 15.8365 14.8447 16.1499 14.8447 16.5365V16.9167C14.8447 17.8556 14.0836 18.6167 13.1447 18.6167H4.88784Z"
        fill={color}
      />
    </svg>
  )
})

export default Copy
